import { cSearch } from "../../../pages/shop/search/search";
import { cHeader } from "../header";

export class cTopSearch {

  script        = document.querySelector('.c-search-data')       as HTMLScriptElement;
  parent        = document.querySelector('.c-top-search')        as HTMLElement;
  input_top     = document.querySelector('.c-top-search input')  as HTMLInputElement;
  body          = document.querySelector('body')                 as HTMLElement;
  button_open   = document.createElement('button');
  input_mobile    = document.createElement('input');
  button_search = document.createElement('button');
  div_container = document.createElement('div');
  div_inner     = document.createElement('div');
  div_prodRes   = document.createElement('div');
  div_listRes   = document.createElement('div');

  products: SearchItemExt[]     = [];
  links   : HTMLAnchorElement[] = [];
  lists   : HTMLAnchorElement[] = [];

  constructor(top: cHeader) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.products = JSON.parse(this.script.textContent) as SearchItemExt[];
    
    this.parent.append(this.button_open);
    this.parent.append(this.div_container);
      this.div_container.append(this.div_inner);
        this.div_inner.append(this.input_mobile);
        this.div_inner.append(this.button_search);
        this.div_inner.append(this.div_prodRes);
        this.div_inner.append(this.div_listRes);

    // ---- Classes ----
    this.button_open.classList.add('c-button-icon');
    this.button_search.classList.add('c-button-icon');
    
    // ---- Other ----
    this.button_open.type       = 'button';
    this.button_open.ariaLabel  = __('Suche', 'custom');
    this.input_mobile.placeholder = __('Suche', 'custom');
    this.input_mobile.name        = 's';
    this.input_mobile.ariaLabel   = __('Suche', 'custom');
    this.input_mobile.type        = 'search';

    // ---- init ----
    this.filterName();

    // ---- Events ----
    this.input_top.addEventListener('keyup', (e) => {
      e.stopPropagation();
      this.input_mobile.value = this.input_top.value;
      this.filterName();
      if (this.input_top.value !== '') {
        this.div_container.classList.add('c-show');
      }
    });

    this.input_top.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      if (this.links.at(0) !== undefined) {
        this.links.at(0)?.focus();
      }
      else if (this.lists.at(0) !== undefined) {
        this.links.at(0)?.focus();
      }
    });

    this.input_top.addEventListener('blur', (e) => {
      const isMoveToList =
        e.relatedTarget && 
        e.relatedTarget instanceof Node &&
        this.div_container.contains(e.relatedTarget);
      
      if (!isMoveToList) {
        top.closeAll();
      }
    });

    this.input_mobile.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      if (this.links.at(0) !== undefined) {
        this.links.at(0)?.focus();
      }
      else if (this.lists.at(0) !== undefined) {
        this.links.at(0)?.focus();
      }
    });

    this.div_container.addEventListener('focusout', (e) => {
      const isMoveToList =
        e.relatedTarget && 
        e.relatedTarget instanceof Node &&
        this.div_container.contains(e.relatedTarget);
      if (!isMoveToList) {
        top.closeAll();
      }
    });

    this.input_mobile.addEventListener('keyup', (e) => {
      this.input_top.value = this.input_mobile.value;
      this.filterName();
      top.closeAll();
      this.div_container.classList.add('c-show');
    });

    this.button_open.addEventListener('click', (e) => {
      e.stopPropagation();
      this.filterName();
      
      if (this.div_container.classList.contains('c-show')) {
        top.closeAll();
      }
      else {
        top.closeAll();
        this.div_container.classList.add('c-show');
      }
    });

    this.div_inner.addEventListener('click', (e)=> {
      e.stopPropagation();
    });

  }

  close() {
    this.div_container.classList.remove('c-show');
  }

  static unifyNames(name: string) {
    // Must be compatible with unifyNames in php
    name = name.toLowerCase();
    name = name.replace('rinds'   , 'rind ');
    name = name.replace('schweins', 'schwein ');
    name = name.replace('kalbs'   , 'kalb ');
    name = name.replace('spätzle' , 'spätzli');
    name = name.replace('é'       , 'e');
    return name;
  }

  
  filterName() {
    const input         = this.input_top.value;
    const allProducts   = this.products;
    const productElm    = this.div_prodRes;
    const listElm       = this.div_listRes;

    cTopSearch.filterNameBase(input, allProducts, productElm, listElm, this);

    this.updateNavigation();
  }

  static filterNameBase(
    input: string, 
    allProducts   : SearchItemExt[], 
    productElm    : HTMLElement,
    listElm       : HTMLElement,
    parent        : cTopSearch | cSearch
  ) {
    // must be compatible with includedInName in php
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const searchNameRaw = input.trim();
    const searchName    = cTopSearch.unifyNames(searchNameRaw);
    const words         = searchName.match(/\w+/g);
    if (words === null) return [];

    let products = 
      allProducts
      .filter(prod => {
        if (searchNameRaw === '') return true;
        const prodName    = cTopSearch.unifyNames(prod.name);
        const hasWords    = words.every(item => prodName.includes(item));
        const hasRawMatch = prod.name.toLowerCase().includes(searchNameRaw.toLowerCase());
        const hasSkuMatch = words.find(item => prod.sku.startsWith(item)) !== undefined;

        return hasWords || hasRawMatch || hasSkuMatch;
      });


    parent.links.forEach(a => a.parentNode?.removeChild(a));
      
    parent.links =   
      products
      .slice(0, 10)
      .map(prod => {
        const a     = document.createElement('a');
        a.href      = prod.url;
        a.innerHTML = `${prod.name}<span class="c-sku"> (#${prod.sku})</span>`;
        a.tabIndex  = -1;
        return a;
      });

    productElm.innerHTML = '';
    parent.links.forEach(a => productElm.append(a));

    const lists =
      products
      .flatMap(prod => prod.lists);

    const listIds         = lists.map(list => list.list_id);
    const distinctListIds = [...new Set(listIds)];

    parent.lists.forEach(a => a.parentNode?.removeChild(a));

    parent.lists = 
      distinctListIds
      .map(id => lists.filter(list => list.list_id === id).find(list => list !== undefined))
      .map(list => {
        const a = document.createElement('a');

        if (list === undefined) {
          a.innerText = 'Error';
          a.href      = '#';
          a.tabIndex  = -1;
          return a;
        }
          
        const name = __('Bestellliste: ', 'custom') + list.name;

        a.href      = `/bestelllisten/${list.list_id}`;
        a.innerText = name;
        a.tabIndex  = -1;
        return a;
      });

    listElm.innerHTML = '';
    parent.lists.forEach(a => listElm.append(a));
  }

  updateNavigation() {

    let top: HTMLInputElement;
    if ('checkVisibility' in Element.prototype) {
      top = 
        this.input_mobile.checkVisibility() 
        ? this.input_mobile
        : this.input_top;
    }
    else {
      top =this.input_top;
    }

    this.links.forEach((link, index) => {

      const next = 
        this.links[index + 1] !== undefined ? this.links[index + 1] :
        this.lists.at(0)      !== undefined ? this.lists.at(0)      :
        this.links.at(0);

      if (next === undefined) return;

      const prev = 
        this.links[index - 1] !== undefined ? this.links[index - 1] : 
        top;

      if (prev === undefined) return;

      link.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          next.focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          prev.focus();
        }
      });
    });

    this.lists.forEach((list, index) => {
      const next = 
        this.lists[index + 1] !== undefined ? this.lists[index + 1] :
        this.links.at(0)      !== undefined ? this.links.at(0)      :
        this.lists.at(0);

      if (next === undefined) return;

      const prev = 
        this.lists[index - 1] !== undefined ? this.lists[index - 1] : 
        this.links.at(-1)     !== undefined ? this.links.at(-1)     : 
        top;
        // this.lists.at(-1);

      if (prev === undefined) return;

      list.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          next.focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          prev.focus();
        }
      });
    });
  }
}